import { isWeb } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { useEffect, useState } from 'react';

import { PageContainer, ScreenTwoPageLayout } from '~/components/Page/Page.Container';
import type { ScreenPropVIRequestsOpen } from '~/navigation/Navigation.types';

import { SupportRequestItem } from '../../SupportRequestItem';
import {
  SupportRequestList,
  SupportRequestListNative,
} from './VirtualInventoryRequest.List';

export const VIRequestsOpenScreen = (props: ScreenPropVIRequestsOpen) => {
  return (
    <PageContainer>
      <VirtualInventoryRequestsLayout {...props} />
    </PageContainer>
  );
};

export const VirtualInventoryRequestsLayout = (props: ScreenPropVIRequestsOpen) => {
  const supportRequestId = props.route.params?.id;
  const [id, setId] = useState<string | undefined>(props.route.params?.id);

  useEffect(() => {
    setId(supportRequestId);
  }, [supportRequestId]);

  return (
    <ScreenTwoPageLayout width={800}>
      {isWeb ? (
        <SupportRequestList onPress={(item) => setId(item.id)} id={id} />
      ) : (
        <SupportRequestListNative />
      )}
      {id ? (
        <SupportRequestItem
          originScreen={'VIRequestsOpen'}
          supportId={id}
          onClose={() => setId(undefined)}
        />
      ) : (
        <></>
      )}
    </ScreenTwoPageLayout>
  );
};
